import { useTranslation } from '@/contexts/i18n-context';
import { InfoRow } from '@/components/encounter/info-row';
import { formatPhoneNumber } from '@/util/helpers';
import styles from './person-information-section.module.css';

interface BasePersonAttributes {
  address1?: string | null;
  address2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  email: string;
  cellPhone?: string | null;
  homePhone?: string | null;
}

export function PersonAttributesSection({
  address1,
  address2,
  city,
  state,
  zip,
  email,
  cellPhone,
  homePhone,
}: BasePersonAttributes) {
  const { t } = useTranslation();

  return (
    <div className={styles.patientDetails}>
      <InfoRow
        icon="location_on"
        title={t('patientInformation.address')}
        details={[address1, address2, city, state, zip].filter(Boolean).join(', ')}
      />
      <InfoRow
        icon="mail"
        title={t('patientInformation.email')}
        details={<p className={styles.email}>{email}</p>}
      />
      <InfoRow
        icon="call"
        title={t('patientInformation.phone')}
        details={formatPhoneNumber(cellPhone ?? homePhone) ?? t('patientInformation.na')}
      />
    </div>
  );
}
